import { useEffect } from "react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import FloatingRebates from "@/components/site/FloatingRebates";
import SmoothScroll from "@/components/site/SmoothScroll";
import PreviewBanner from "@/components/site/PreviewBanner";
import { localBusinessSchema, websiteSchema } from "@/lib/schema";

// Inject site-wide JSON-LD (LocalBusiness + WebSite) once, at the layout level.
// Route-specific schema is added via useSEO in each page.
function useSiteSchema() {
  useEffect(() => {
    const items = [
      { id: "site-jsonld-business", data: localBusinessSchema() },
      { id: "site-jsonld-website", data: websiteSchema() },
    ];
    items.forEach(({ id, data }) => {
      let el = document.getElementById(id);
      if (!el) {
        el = document.createElement("script");
        el.type = "application/ld+json";
        el.id = id;
        document.head.appendChild(el);
      }
      el.textContent = JSON.stringify(data);
    });
  }, []);
}

export default function Layout({ children }) {
  useSiteSchema();
  return (
    <div className="bg-[#0A0A0A] text-white min-h-screen">
      <PreviewBanner />
      <SmoothScroll />
      <Header />
      <FloatingRebates />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
